import styles from '../checkbox/checkbox.module.scss';
import {
  FieldValues,
  useController,
  UseControllerProps
} from "react-hook-form";

type CheckboxProps<T extends FieldValues> = {
  disabled?: boolean;
} & UseControllerProps<T>;

export const CheckboxHookForm = <T extends FieldValues>({ disabled, control, name, rules, defaultValue }: CheckboxProps<T>) => {
  const {
    field: { ref, ...inputProps },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  return (
    <div className={styles.container}>
      <input
        type="checkbox"
        {...inputProps}
        checked={inputProps.value}
        disabled={disabled}
        ref={ref}
      />
    </div>
  );
}